import React from 'react';
import PropTypes from 'prop-types';

import { ButtonFilled, SvgIcon, Text, Flex } from 'Components/Base';

const ReplayButton = ({ onClick }) => {
  return (
    <ButtonFilled
      color={'warning'}
      onClick={onClick}
      width={'100%'}
      height={'130px'}
      mr={3}
      borderRadius={2}
    >
      <Flex justifyContent={'center'} alignItems={'center'} flexDirection={'column'}>
        <SvgIcon icon={SvgIcon.ICON_LIST.REPLAY} size={36} color={'greyscale.grey2'} mb={2} />
        <Text textStyle={'heading5'} color={'greyscale.grey2'}>
          ดูอีกครั้ง
        </Text>
      </Flex>
    </ButtonFilled>
  );
};

ReplayButton.propTypes = {
  onClick: PropTypes.func,
};

export default ReplayButton;
